var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-b-badge',{staticClass:"icon-badge",attrs:{"pill":""}},[_vm._t("icon"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }